module.exports = __webpack_public_path__ + "static/img/slide_10.51955cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/slider/slide_10.png
// module id = 0j4l
// module chunks = 0